import {Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID} from '@angular/core';
import {Address} from '../interface/address';
import {ToastMessageService} from 'src/app/services/toast-message.service';
import {AddressTransmissionService} from 'src/app/raintree/transmission/address-transmission/address-transmission.service';
import {RequestMapperService} from 'src/app/request-mapper.service';
import {RaintreeResponse} from 'src/app/raintree/interface/raintree-response';
import {AddressFunctionService} from '../service/address-function.service';
import {isPlatformBrowser} from '@angular/common';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ConfirmDialogComponent} from "../../components-library/miscellaneous/confirm-dialog/confirm-dialog.component";

@Component({
	selector: 'fb-address-list',
	templateUrl: './address-list.component.html',
	styleUrls: ['./address-list.component.scss']
})
export class AddressListComponent implements OnInit {

	@Input() addressData: Address = {} as Address;
	@Output() defaultAddressUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() editAddress: EventEmitter<Address> = new EventEmitter<Address>();
	@Output() deleteAddress: EventEmitter<Address> = new EventEmitter<Address>();


	@Output() addressSaved: EventEmitter<boolean> = new EventEmitter<boolean>();
	public isCheckoutPage: boolean = false;
	public isBrowser: boolean = false;

	constructor(
		public _toast: ToastMessageService,
		private _addressTransmission: AddressTransmissionService,
		private _addressFuncService: AddressFunctionService,
		private _dialog: MatDialog,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	public ngOnInit(): void {
		if (this.isBrowser && window.location.href.includes(RequestMapperService.CHECKOUT)) {
			this.isCheckoutPage = true
		}
	}

	public setDefaultAddress(): void {

		if (this.addressData.addressType === "BILLING") this.addressData.primaryBillingAddress = true;
		else this.addressData.primaryShippingAddress = true;

		this.updateAddress();

	}

	public selectThisAddress(data: Address): void {

		this._addressFuncService.methSelectedAddress(data);
	}

	public editAddressMeth(): void {

		this.editAddress.emit(this.addressData);
	}

	public deleteAddressMeth(): void {
		const dialogRef: MatDialogRef<ConfirmDialogComponent> = this._dialog.open(ConfirmDialogComponent, {
			width: '400px',
			data: '',
		});
		dialogRef.afterClosed().subscribe((result: boolean): void => {
			if (result) {
				this.deleteAddress.emit(this.addressData);
			}
		});
	}

	public updateAddress(): void {

		this._addressTransmission.updateAddres(
			RequestMapperService.UPDATE_ADDRESS,
			this.addressData,
			(): void => {
			},
			(): void => {
			},
			(response: RaintreeResponse): void => {
				this._toast.success(response.message, response.message);
				this.defaultAddressUpdate.emit();
			},
			(error: string): void => {
				this._toast.error(error, error);
			},
			(): void => {
			}
		)

	}
}
